import { requestApi } from './helper';
import { invalidateDestinationList, invalidateDestination } from './destination';

export const SAVE_TASK = 'SAVE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';

export const saveTask = (task, dispatch) => {
  dispatch(invalidateDestinationList());
  dispatch(invalidateDestination(task.destinationId));

  return { type: SAVE_TASK, task };
};

export const updateTask = (task, dispatch) => {
  dispatch(invalidateDestinationList());
  dispatch(invalidateDestination(task.destinationId));

  return { type: UPDATE_TASK, task };
};

export const requestSaveTask = (task, errorCallback, successCallback) => {
  const requestProperties = {
    method: 'POST',
    body: task,
  };

  return requestApi('/tasks', requestProperties, saveTask, errorCallback, successCallback);
};

export const requestUpdateTask = (task, errorCallback, successCallback) => {
  const jsonTask = JSON.parse(task);
  const requestProperties = {
    method: 'PATCH',
    body: task,
  };

  return requestApi(`/tasks/${jsonTask.taskId}`, requestProperties, updateTask, errorCallback, successCallback);
};



// WEBPACK FOOTER //
// ./src/actions/task.js